import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import { ButtonContained } from '../components/app-button/button'
import cx from 'classnames'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import CrmApplicationForm from '../components/app-form/CrmApplicationForm'
import AppBarInner from '../components/app-bar/AppBarInner'
import Wrapper from '../components/wrapper'
import AppStepper from '../components/app-stepper'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import CustomizeAll from '../components/сustomize-all/'
import Slide from '@material-ui/core/Slide'
import Snackbar from '@material-ui/core/Snackbar'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

function Transition(props) {
  return <Slide direction="left" {...props} />
}

import {
  AccountIdentifierIcon,
  AccountWaitIcon,
  AccountAlertIcon,
  AddItemIcon,
  AmoCrmBigIcon,
  Bitrix24BigIcon,
  BitrixBigIcon,
  RetailCrmBigIcon,
  EnvyCrmBigIcon,
  ArrowAside,
  UonCrmBigIcon, YclientsIcon,
} from '../components/app-icon/Icons'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  wizardContent: {
    marginLeft: 74,
  },
  chanelList: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
  chanel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px',
    transition: 'background-color .2s linear',
    '&:hover': {
      backgroundColor: 'rgb(255, 204, 0, 0.2)',
    },
  },
  chanelInfo: {
    listStyleType: 'none',
    padding: 0,
    marginLeft: 8,
    marginRight: 65,
    flex: 1,
  },
  chanelTitle: {
    fontFamily: 'Roboto',
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.75)',
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    lineHeight: 1.6,
    color: 'rgba(0, 0, 0, 0.5)',
  },
  chanelStatusIcon: {
    width: 16,
    height: 16,
  },
  listChanel: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginLeft: 6,
    marginTop: 30,
    padding: 0,
    listStyleType: 'none',
    flexWrap: 'wrap',
  },
  ChanelItem: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 90,
    height: 64,
    marginRight: 30,
    marginBottom: 30,
    borderRadius: '100%',
    // border: 'solid 1px rgba(0, 0, 0, 0.1)',
    backgroundColor: 'rgb(255, 255, 255)',
  },
  ChanelIcon: {
    width: 35,
    height: 35,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  ChanelStatus: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100%',
    position: 'absolute',
    bottom: -10,
    right: -7,
    width: 24,
    height: 24,
    border: 'solid 1px rgba(0, 0, 0, 0.1)',
    backgroundColor: 'rgb(255, 255, 255)',
    cursor: 'pointer',
  },
  ChanelAddIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 13,
    height: 13,
  },
  ChanelRemoveIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 13,
    height: 13,
  },
  content: {
    padding: '0 40px 30px 22px',
  },
  active: {
    border: 'solid 1px #8866ff',
    boxShadow: '0 0 8px 0 #8866ff80',
    '& span': {
      border: 'solid 1px #8866ff',
      boxShadow: '0 0 8px 0 #8866ff80',
    },
  },
  finishBtn: {
    display: 'block',
    textDecoration: 'none',
    marginTop: 25,
    position: 'relative',
    left: 0,
    width: 160,
    '&::after': {
      content: '" "',
      position: 'absolute',
      bottom: '100%',
      left: 14,
      height: 25,
      width: 1,
      backgroundColor: 'rgba(136, 102, 255, 0.2)',
    },
  },
  finishContent: {
    position: 'relative',
    marginTop: 20,
    fontFamily: 'Caveat, cursive',
    letterSpacing: 1.1,
    color: 'rgba(0, 0, 0, 0.6)',
  },
  crmBlock: {
    marginTop: '16px',
    width: '350px',
    padding: '16px 14px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '14px',
  },
  newCrm: {
    width: '188px',
  },
  crmButtonNew: {
    width: '126px',
    height: '32px',
    lineHeight: '32px',
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'center',
    borderRadius: '4px',
    border: 'solid 1px #8866ff',
    backgroundColor: '#fff',
    outline: 'none',
    textDecoration: 'none',
    color: '#000',
  },

  appBar: {
    position: 'relative',
  },
  paper: { backgroundColor: '#ffcc00' },
  modalTitle: {
    marginBottom: 24,
    textAlign: 'center',
  },
  modalIcon: {
    marginBottom: 16,
  },
  subTitle: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: 'rgb(0, 0, 0)',
    textAlign: 'center',
    whiteSpace: 'pre-line',
  },
  arrowAside: {
    position: 'absolute',
    left: -75,
    marginTop: 25,
  },
})

function getSteps() {
  return [
    `Аккаунт \nподтвержден`,
    'Сайт \nдобавлен',
    'Google Analytics \nнастроен',
    'Добавьте каналы \nдля сбора данных \nо расходах',
    'Подключение CRM\nсистемы',
    'Подключение\nколлтрекинга',
  ]
}

class CrmSetting extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openModal: false,
      openSnakbar: false,
      activeStep: 4,
      dataSources: window.state.dataSources,
      errorMessage: window.state.errorMessage,
      isCard: window.state.cardTest,
    }
  }

  successData = status => {
    if (status === 'ok') {
      this.timer = setTimeout(
        () =>
          this.setState({
            openModal: false,
            isFetching: false,
            openSnakbar: true,
          }),
        600
      )
    }
  }

  handleClickOpen = event => {
    event.preventDefault()
    this.setState({ openModal: true })
  }

  handleClose = () => {
    this.setState({ openModal: false, isFetching: false })
  }

  handleCloseSnakbar = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    this.setState({ openSnakbar: false })
  }

  handleSubmit = values => {
    this.setState({
      isFetching: true,
    })

    const url = '/crm/create'

    const options = values => ({
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }

      this.setState({
        isFetching: false,
      })
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options(values))
      .then(handleResponse)
      .then(({ status }) => {
        this.successData(status)
      })
      .catch(errors)
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  handleNewCrm(e, crm) {
    crm = crm || ''

    let fetching = this.state.fetching
    fetching[crm] = true
    this.setState({ fetching: fetching })

    let data = {
      crm_name: crm,
      description: '',
    }

    const url = '/crm/create'

    const json = response => {
      return response.json()
    }

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(data),
    })
      .then(status)
      .then(json)
      .then(data => {
        let crmApplications = this.state.crmApplications
        crmApplications[crm] = true

        let fetching = this.state.fetching
        fetching[crm] = true

        this.setState({
          fetching: fetching,
          crmApplications: crmApplications,
        })
      })
      .catch(function(error) {
        console.log('Request failed', error)
      })

    e.preventDefault()
  }

  render() {
    const { classes } = this.props
    const {
      dataSources,
      errorMessage,
      isCard,
      openModal,
      openSnakbar,
    } = this.state

    const steps = isCard ? getSteps() : getSteps().slice(0, -1)

    const icon = type => {
      switch (type) {
        case 'amo_crm':
          return <AmoCrmBigIcon className={classes.ChanelIcon} width={100} />
        case 'bitrix24':
          return <Bitrix24BigIcon className={classes.ChanelIcon} width={100} />
        case 'bitrix':
          return <BitrixBigIcon className={classes.ChanelIcon} width={100} />
        case 'envy':
          return <EnvyCrmBigIcon className={classes.ChanelIcon} width={100} />
        case 'retail':
          return <RetailCrmBigIcon className={classes.ChanelIcon} width={100} />
        case 'uon':
          return <UonCrmBigIcon className={classes.ChanelIcon} width={80} />
        case 'YClients':
          return <YclientsIcon className={classes.ChanelIcon} width={80} />
        default:
          break
      }
    }

    const action = status => {
      switch (status) {
        case 'inactive':
          return <AddItemIcon className={classes.ChanelAddIcon} />
        case 'active':
          return <OkIcon className={classes.ChanelRemoveIcon} />
        default:
          break
      }
    }

    const statusSymbol = type => {
      switch (type) {
        case 'wait':
          return <AccountWaitIcon className={classes.chanelStatusIcon} />
        case 'ok':
          return <AccountIdentifierIcon className={classes.chanelStatusIcon} />
        case 'error':
          return <AccountAlertIcon className={classes.chanelStatusIcon} />
        default:
          break
      }
    }

    return (
      <div className={classes.pageTemplate}>
        <AppBarInner />
        <CustomizeAll />

        <div className={classes.wizardRow}>
          <LeftNavigationDashboard />
          <div style={{ width: 200, position: 'relative' }}>
            <AppStepper activeStep={this.state.activeStep} steps={steps} />

            <ArrowAside width={63} height={83} className={classes.arrowAside} />

            <a
              href="/wizard/calltracking/settings"
              className={classes.finishBtn}
            >
              <ButtonContained full={true} color="primary" text="Далее" />
            </a>

            <a
              href="/wizard/sources/settings"
              className={classes.finishBtn}
            >
              <ButtonContained full={true} text="Назад" />
            </a>

            <p className={classes.finishContent}>
              Вы сможете добавить используемую CRM-систему для передачи
              информации о сделках позже из меню настроек.
            </p>
          </div>
          <div className={classes.wizardContent}>
            <Wrapper shadow={4}>
              <section className={classes.content}>
                <Typography variant="h3" paragraph style={{ paddingTop: 24 }}>
                  Подключение CRM системы
                </Typography>
                <Typography
                  variant="subtitle1"
                  paragraph
                  style={{
                    padding: '6px 13px 6px',
                    backgroundColor: 'rgba(136, 102, 255, .15)',
                  }}
                >
                  Обратите внимание, чтобы данные о продажах из вашей CRM
                  передавались корректно, необходимо подключить передачу Google
                  Client ID в вашу CRM систему при заказе на сайте
                </Typography>

                {errorMessage ? (
                  <p
                    style={{
                      paddingLeft: 6,
                      fontSize: 14,
                      color: 'red',
                    }}
                  >
                    {errorMessage}
                  </p>
                ) : null}

                <ul className={classes.listChanel}>
                  {dataSources.map(({ addUrl, settingsUrl, type, status }) => (
                    <li
                      key={type}
                      className={cx(classes.ChanelItem, {
                        [classes.active]: status === 'active',
                      })}
                    >
                      <a href={status === 'inactive' ? addUrl : settingsUrl}>
                        {icon(type)}
                        <span className={classes.ChanelStatus}>
                          {action(status)}
                        </span>
                      </a>
                    </li>
                  ))}
                </ul>
                <div className={classes.crmBlock}>
                  <div className={classes.newCrm}>
                    <b>В списке нет вашей CRM?</b>
                    Оставьте заявку.
                  </div>
                  <a
                    href="#"
                    className={classes.crmButtonNew}
                    onClick={this.handleClickOpen}
                  >
                    Заявка
                  </a>
                </div>
              </section>
            </Wrapper>
          </div>
        </div>
        <div>
          <Dialog
            fullScreen
            open={openModal}
            onClose={this.handleClose}
            TransitionComponent={Transition}
            PaperProps={{
              classes: {
                root: this.props.classes.paper,
              },
            }}
          >
            <AppBar className={this.props.classes.appBar} elevation={0}>
              <Toolbar style={{ paddingTop: 16 }}>
                {/* <LogoHelpData /> */}
                <IconButton
                  color="inherit"
                  onClick={this.handleClose}
                  aria-label="Close"
                  style={{ marginLeft: 'auto' }}
                >
                  <CloseIcon style={{ fill: '#fff' }} />
                </IconButton>
              </Toolbar>
            </AppBar>
            <div
              style={{
                maxWidth: 400,
                width: '100%',
                margin: '0 auto',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <header className={classes.modalTitle}>
                {/* <DishIcon width={48} height={32} className={classes.modalIcon} /> */}
                <h6
                  style={{
                    fontFamily: 'Roboto',
                    fontSize: 24,
                    fontWeight: 'bold',
                    fontStyle: 'normal',
                    fontStretch: 'normal',
                    lineHeight: 'normal',
                    letterSpacing: 'normal',
                    textAlign: 'center',
                    color: 'rgb(0, 0, 0)',
                    margin: '0 0 24px 0',
                  }}
                >
                  Напишите нам!
                </h6>
                <div className={classes.subTitle}>
                  {`Какую CRM вы используете?`}
                </div>
              </header>
              <Wrapper
                shadow={1}
                style={{
                  width: '100%',
                  borderRadius: 8,
                  overflow: 'hidden',
                  padding: '40px 50px 50px 50px',
                  backgroundColor: 'rgb(255, 255, 255)',
                  fontFamily: '"Exo 2", "Helvetica", "Arial", sans-serif',
                  lineHeight: 1.5,
                }}
              >
                <CrmApplicationForm
                  onSubmit={this.handleSubmit}
                  isFetching={this.state.isFetching}
                  // initialValues={{ email: user.email, phone: user.phone }}
                />
              </Wrapper>
            </div>
          </Dialog>

          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open={openSnakbar}
            autoHideDuration={5000}
            onClose={this.handleCloseSnakbar}
            ContentProps={{
              'aria-describedby': 'message-id',
            }}
            message={<span id="message-id">Заявка отправлена!</span>}
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                className={classes.close}
                onClick={this.handleCloseSnakbar}
              >
                <CloseIcon />
              </IconButton>,
            ]}
          />
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(CrmSetting)
